import Global from '../module/Global';
import Modal from '../module/Modal';
import CcSearch from '../app/CcSearch';
import PmSearch from '../app/PmSearch';
import Result from '../app/Result';
import Form from '../module/Form';
import Region from '../module/Region';

window.onload = () => {
	const container = document.getElementById('container');
	const app = document.getElementById('search_app');
	const result = document.getElementById('result');

	// 共通ヘッダ・フッタ
	new Global();
	// ログインモーダル
	new Modal();

	// 国選択
	if (container.classList.contains('region')) {
		new Region();
	}

	// 検索アプリ
	if (app) {
		// CAS NUMBER
		if (app.classList.contains('cc')) {
			new CcSearch(app);
		} else {
			// PRODUCT
			new PmSearch(app);
		}
	}

	// 検索結果ページ
	if (result) {
		new Result();
	}

	// form関連
	if (container.classList.contains('form')) {
		new Form();
	}
};



// WEBPACK FOOTER //
// ./src/js/entry/common.js